module.exports = __webpack_public_path__ + "static/media/player_open.48fb7f4c.png";